import classes from './DashboardContentHeading.module.scss';
import IconContainerDash from './IconContainerDash/IconContainerDash';

const DashboardContentHeading = ({iconText}) => {


    let showIcon;
    let showHeading;

    switch(iconText) {
        case('auctionSchedule'):
            showHeading = (<h5>Auction Schedule</h5>);
            showIcon = (<IconContainerDash iconText={iconText}/>)
            break;

        case('favorites'):
            showHeading = (<h5>My favorites</h5>);
            showIcon = (<IconContainerDash iconText={iconText}/>)
            break;

        case('auction'):
            showHeading = (<h5>Auction</h5>);
            showIcon = (<IconContainerDash iconText={iconText}/>)
            break;

        case('inspection'):
            showHeading = (<h5>Inspections</h5>);
            showIcon = (<IconContainerDash iconText={iconText}/>)
            break;

        case('purchases'):
            showHeading = (<h5>Recent Purchases</h5>);
            showIcon = (<IconContainerDash iconText={iconText}/>)
            break;
        default:
    }

    return (
        <div className={classes.DashboardContentHeading}>
            {showIcon}
            {showHeading}
        </div>
    )
}

export default DashboardContentHeading;